import { StyledDot } from "domains/Fidelity/style";
import React from "react";

interface DotIndicatorProps {
  isSelected: boolean;
  width?: string;
  height?: string;
}
function DotIndicator({ isSelected, height = "16px", width = "16px" }: DotIndicatorProps) {
  return <StyledDot isSelected={isSelected} height={height} width={width} />;
}

export default DotIndicator;
